import { Component, OnInit, ElementRef, Renderer2, ViewChild, Input, DoCheck } from '@angular/core';
import { PopoverComponent } from 'src/app/reports/shared/popover/popover.component';
import { getCoordinateFromMouseEvent } from 'src/app/reports/shared/link/helpers/element-position.helper';
import { setElementPositionByCoordinates } from 'src/app/reports/helpers/element-style.helper';
import { FilterOptionsService } from './filter-options.service';
import { BaseComponent } from 'src/app/reports/shared/utils/base.component';
import { OpenFilterOptions } from './open-filter-options.model';
import { Filter } from '../../models/filter.model';
import { ObjectValue } from 'src/app/reports/models/object-value.model';
import { FilterTypeEnum } from 'src/app/reports/enums/filter-type.enum';
import { PropertyType } from 'src/app/reports/shared/rte-form/schema/property-type.enum';
import { ReportEntity } from '../../models/report-entity.model';
import { EntityTypeEnum } from 'src/app/reports/enums/entity-type.enum';
import { ReportFormComponent } from '../report-form.component';
import { FormControl, FormControlName } from '@angular/forms';

@Component({
  selector: 'app-filter-options',
  templateUrl: './filter-options.component.html',
  styleUrls: ['./filter-options.component.scss']
})
export class FilterOptionsComponent extends BaseComponent implements OnInit, DoCheck {

  @Input() sessionId: string;
  @Input() disabled: boolean;
  @Input() entities: Array<ReportEntity>;

  @ViewChild(PopoverComponent) popOverRef: PopoverComponent;

  //#region Properties
  search = false;
  isActive = false;
  selected: Filter = new Filter();
  filterOptions: ObjectValue[];
  INTERNALTYPE = FilterTypeEnum.Interval;
  LIST = FilterTypeEnum.List;
  MULTILIST = FilterTypeEnum.MultiList;
  entitiesList: Array<ReportEntity>;
  entityListId: number;
  listSelect: FormControlName;

  //#endregion

  constructor(public element: ElementRef,
    private renderer: Renderer2,
    private service: FilterOptionsService) {
      super();
    }

  ngOnInit() {
    this.subscription.add(
      this.service.onOpenFilterOptions.subscribe((x: OpenFilterOptions) => {
        if (x.sessionId === this.sessionId) {
          this.selected = x.data;
          this.filterOptions = this.service.getFilterTypeOptionsByColumnType(this.selected.ColumnType);
          this.onMoreOptionsClicked(x.event);
        }
      })
    );
  }

  ngDoCheck() {
    this.filtersEntities();
  }

  filtersEntities() {
    this.entitiesList = this.entities.filter(x => x.Entity.EntityType === EntityTypeEnum.List);
  }

  getParentElement(): Element {
    if (this.search) {
      const search = document.getElementsByClassName('filters');
      if (search && search.length > 0) {
        return search[0];
      }
      return null;
    }
    return null;
  }

  //#region Events

  onMoreOptionsClicked(event: MouseEvent) {
    this.isActive = !this.isActive;

    if (this.isActive) {

      this.search = true;
      const coordinates = getCoordinateFromMouseEvent(event, this.element.nativeElement.parentElement);
      coordinates.x -= 280;

      const triangleRef = this.popOverRef.triangleRef.nativeElement,
       contentRef = this.popOverRef.contentRef.nativeElement;

      this.renderer.setStyle(triangleRef, 'left', 'calc(100% - 55px)');

      setElementPositionByCoordinates(coordinates, contentRef, this.renderer);
    }
  }

  closeMoreOptions() {
    this.isActive = false;
  }

  onTypeChanged() {
    if (this.selected && this.selected.Type !== this.INTERNALTYPE) {
      this.selected.IsFileUpload = false;
    } else if (this.selected && (this.selected.Type !== this.LIST || this.selected.Type !== this.MULTILIST)) {
      this.selected.EntityListId = 0;
    }
  }

  //#endregion
}
